import {createReducer, on} from '@ngrx/store';
import {
  GetPropertyViewingAvailabilitiesResponseModel,
  ViewingAvailabilityModel
} from '../../../shared/models/properties/property-availability.models';
import {
  GetUserViewingAvailabilitiesResponseModel,
  SellersWeekAvailabilitiesModel
} from '../../../shared/models/users/user-availability.models';
import {
  SelectedWeeksModel,
  SetCalendarWidgetDateModel,
  SetCalendarWidgetSettingsModel,
  SetCalendarWidgetTimeModel, SetHostDetailsModel, SetHostIdModel, SetIsHostedBySellerModel, SetIsLoadingDistanceModel, SetSelectedDateModel
} from '../../models/calendar-widget.model';
import {AppointmentModel} from '../../../shared/models/calendar/appointments.models';
import {PropertyDistanceModel} from '../../../shared/models/google/google-maps.models';
import {GetUserAppointmentsResponseModel, UserDetailsModel} from '../../../shared/models/users/users.models';
import { CalendarWidgetActions } from '../../actions/calendar/calendar-widget.actions';

export const calendarWidgetKey = 'calendarWidget';

export interface State {
  isInitialing: boolean;
  isLoadingAvailability: boolean;
  selectedDate: string;
  selectedTime: ViewingAvailabilityModel;
  selectedWeeks: SelectedWeeksModel;
  availability: Array<ViewingAvailabilityModel[]>;
  sellerAvailability: SellersWeekAvailabilitiesModel;
  availabilityError: string;
  initialingError: string;
  slotDuration: number;
  availabilityDuration: number;
  hostId: number;
  hostDetails: UserDetailsModel;
  propertyId: number;
  initialSettings: object;
  isHostedBySeller: boolean;
  agentAppointments: AppointmentModel[];
  agentAppointmentsDistances: PropertyDistanceModel[];
  isLoadingDistance: boolean;
}

export const initialState: State = {
  isInitialing: true,
  isLoadingAvailability: false,
  selectedDate: null,
  selectedTime: null,
  selectedWeeks: null,
  availability: null,
  sellerAvailability: null,
  availabilityError: null,
  initialingError: null,
  slotDuration: null,
  availabilityDuration: null,
  hostId: null,
  hostDetails: null,
  propertyId: null,
  initialSettings: null,
  isHostedBySeller: null,
  agentAppointments: null,
  agentAppointmentsDistances: null,
  isLoadingDistance: false,
};

export const reducer = createReducer(
  initialState,
  on(
    CalendarWidgetActions.setCalendarWidgetSettings,
    (state: State, res: SetCalendarWidgetSettingsModel) => ({
      ...state,
      propertyId: res.propertyId,
      slotDuration: res.calendarParams['slot-duration'],
      availabilityDuration: res.calendarParams['availability-duration'],
      initialSettings: res.calendarParams,
      isInitialing: true
    })
  ),
  on(
    CalendarWidgetActions.initCalendarWidget,
    (state: State) => ({
      ...state,
      isInitialing: true
    })
  ),
  on(
    CalendarWidgetActions.loadPropertyViewingAvailability,
    (state: State) => ({
      ...state,
      isInitialing: false,
      isLoadingAvailability: true
    })
  ),
  on(
    CalendarWidgetActions.setPropertyViewingAvailability,
    (state: State, res: GetPropertyViewingAvailabilitiesResponseModel) => ({
      ...state,
      availability: res.data,
      isLoadingAvailability: false
    })
  ),
  on(
    CalendarWidgetActions.setCalendarWidgetDate,
    (state: State, res: SetCalendarWidgetDateModel) => ({
      ...state,
      selectedDate: res.date,
      availability: [],
      availabilityError: null,
      isLoadingAvailability: true,
      agentAppointmentsDistances: null
    })
  ),
  on(
    CalendarWidgetActions.setCalendarWidgetTime,
    (state: State, res: SetCalendarWidgetTimeModel) => ({
      ...state,
      selectedTime: res.details,
    })
  ),
  on(
    CalendarWidgetActions.setSelectedDate,
    (state: State, res: SetSelectedDateModel) => ({
      ...state,
      selectedDate: res.date,
    })
  ),
  on(
    CalendarWidgetActions.setHostId,
    (state: State, res: SetHostIdModel) => ({
      ...state,
      hostId: res.id,
    })
  ),
  on(
    CalendarWidgetActions.setHostDetails,
    (state: State, res: SetHostDetailsModel) => ({
      ...state,
      hostDetails: res.hostDetails,
    })
  ),
  on(
    CalendarWidgetActions.setIsHostedBySeller,
    (state: State, res: SetIsHostedBySellerModel) => ({
      ...state,
      isHostedBySeller: res.status,
    })
  ),
  on(
    CalendarWidgetActions.setUserViewingAvailability,
    (state: State, res: GetUserViewingAvailabilitiesResponseModel) => ({
      ...state,
      sellerAvailability: res.data,
    })
  ),
  on(
    CalendarWidgetActions.loadUserAppointmentsSuccess,
    (state: State, res: GetUserAppointmentsResponseModel) =>  ({
        ...state,
        agentAppointments: res.data
      })
  ),
  on(
    CalendarWidgetActions.loadDistanceCalculationSuccess,
    (state: State, res: any) => ({
      ...state,
      agentAppointmentsDistances: res.data,
    })
  ),
  on(
    CalendarWidgetActions.setSelectedCalendarWeeks,
    (state: State, res: SelectedWeeksModel) => ({
      ...state,
      selectedWeeks: {
        startDate: res.startDate,
        endDate: res.endDate
      }
    })
  ),
  on(
    CalendarWidgetActions.setIsLoadingDistance,
    (state: State, res: SetIsLoadingDistanceModel) => ({
      ...state,
      isLoadingDistance: res.status,
    })
  ),
);
